import { HorizontalContainer, Skeleton } from '@/components';

import { PropertyObjectType } from '@/caregiverSpace/shared/model';

type DetailsContainerProps = {
    properties: PropertyObjectType[];
    isLoading: boolean;
};
export const DetailsContainer = ({
    properties,
    isLoading,
}: DetailsContainerProps) => {
    if (!isLoading && properties.length === 0) {
        return null;
    }

    return (
        <div className="grid grid-cols-2 gap-4">
            {!isLoading &&
                properties.map((property) => (
                    <HorizontalContainer spacing="xs" key={property.label}>
                        <b className="font-bold">{property.label}:</b>
                        <span>{property.value}</span>
                    </HorizontalContainer>
                ))}

            {isLoading &&
                Array.from({ length: 4 }).map((_, index) => (
                    <HorizontalContainer spacing="xs" key={index}>
                        <b className="font-bold">
                            <Skeleton className="h-6" />
                        </b>
                        <span>
                            <Skeleton className="h-6" />
                        </span>
                    </HorizontalContainer>
                ))}
        </div>
    );
};
